{
    "action__edit": "Bearbeiten",
    "action__copy_address": "Adresse kopieren"
}
